import { InputGroup } from 'react-bootstrap'
import IconActionWrapper from './button/IconActionWrapper'

const InputAppend = (props) => {
  let { uischema } = props
  let { appendIcon = null, appendIconTooltip = null } = uischema
  if (appendIcon) {
    return (
      <InputGroup.Append>
        <IconActionWrapper
          {...props}
          iconName={appendIcon}
          iconTooltip={appendIconTooltip}
          modalOpenSource="inputAppend"
          border={{ borderRadius: '0 6px 6px 0' }}
        />
      </InputGroup.Append>
    )
  }
  return ''
}

export default InputAppend
